import { initializeApp } from 'firebase/app';
import {
    getAuth,
    GoogleAuthProvider,
    setPersistence,
    browserLocalPersistence,
    indexedDBLocalPersistence,
} from 'firebase/auth';

// Production web config (public by design — it ships in the bundle). A build
// for another environment overrides it field by field with VITE_FIREBASE_*
// (e.g. `vite build --mode staging` reads FE/.env.staging, #412), so the
// staging app signs users into the STAGING Firebase project, never prod's.
// Local dev and E2E set none of these and keep the production project.
const PROD_FIREBASE_CONFIG = {
    apiKey: "AIzaSyAJz7xdD9_VnA8OiuUF7PrQab_xpQAsY84",
    authDomain: "gen-lang-client-0755446306.firebaseapp.com",
    projectId: "gen-lang-client-0755446306",
    storageBucket: "gen-lang-client-0755446306.firebasestorage.app",
    messagingSenderId: "1098547177782",
    appId: "1:1098547177782:web:29abee53845443d6d06b97",
    measurementId: "G-75TZDPYJ50"
};

const env = import.meta.env;
const firebaseConfig = {
    apiKey: env.VITE_FIREBASE_API_KEY || PROD_FIREBASE_CONFIG.apiKey,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || PROD_FIREBASE_CONFIG.authDomain,
    projectId: env.VITE_FIREBASE_PROJECT_ID || PROD_FIREBASE_CONFIG.projectId,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || PROD_FIREBASE_CONFIG.storageBucket,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || PROD_FIREBASE_CONFIG.messagingSenderId,
    appId: env.VITE_FIREBASE_APP_ID || PROD_FIREBASE_CONFIG.appId,
    // Analytics only exists on prod; another project must not inherit prod's id.
    measurementId: env.VITE_FIREBASE_PROJECT_ID
        ? env.VITE_FIREBASE_MEASUREMENT_ID || undefined
        : PROD_FIREBASE_CONFIG.measurementId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Belt-and-suspenders: explicitly pin persistence so the refresh token
// survives sleep/wake cycles, tab restores, and full browser restarts.
// IndexedDB is preferred (works across tabs, larger quota); browserLocal
// fallback covers environments where IndexedDB is disabled. The default
// is already browserLocalPersistence on web, but we pin it to guard
// against future SDK default changes — the spec's "session must remain
// active across system sleep modes and lid closures" depends on this.
setPersistence(auth, indexedDBLocalPersistence).catch(() => {
    setPersistence(auth, browserLocalPersistence).catch(() => { /* nothing left */ });
});

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;
